import { IsOptional, IsString } from 'class-validator';

export class Bs2IntegracaoCancelarDto {
  @IsString()
  @IsOptional()
  justificativa?: string;
}
